import { createSlice } from "@reduxjs/toolkit";

export const collectionSlice = createSlice({
  name: "collection",
  initialState: {
    loading: false,
    collectionList: [],
    listCount: 0,
    collectionParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
    },
  },
  reducers: {
    getCollectionList: (state) => ({ ...state, loading: true }),
    collectionListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.count / state.collectionParams.page_size
      );
      return {
        ...state,
        listCount: action.payload.count,
        collectionList: action.payload.results,
        loading: false,
        collectionParams: { ...state.collectionParams, no_of_pages: noofpages },
      };
    },
    setCollectionParams: (state, action) => ({
      ...state,
      collectionParams: action.payload,
    }),
    apiError: (state, action) => ({
      ...state,
      loading: false,
      error_msg: action.payload,
    }),
  },
});

export const {
  getCollectionList,
  collectionListSuccessful,
  setCollectionParams,
  apiError,
} = collectionSlice.actions;

export default collectionSlice.reducer;
